<template>
    <form @submit.prevent="$emit('onEvent', {id: data.id, users: category_users})">
        <app-model :class="{ 'show': show }">
            <template v-slot:header class="modal-header d-flex align-items-center">
                <h4 class="card-title mb-0">Actualizar registro</h4>
                <button type="button" @click="onClose()" class="btn-close"></button>
            </template>
            <template v-slot:body class="modal-body">
                <div class="row">
                    <div class="col-12">
                        <div class="form-group mb-3">
                            <label class="control-label">Usuarios</label>
                            <v-autocomplete
                                :items="users"
                                v-model="category_users"
                                item-text="name"
                                item-value="id"
                                multiple
                                class="form-control"
                                dense
                                chips
                                chips-small
                                hide-details
                                outlined>
                                <template v-slot:selection="{ item, index }">
                                  <v-chip v-if="index === 0">
                                    <span>{{ item.name }}</span>
                                  </v-chip>
                                  <span
                                    v-if="index === 1"
                                    class="grey--text text-caption"
                                  >
                                    (+{{ category_users.length - 1 }} others)
                                  </span>
                                </template>
                            </v-autocomplete>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:footer class="modal-footer">
                <button type="submit" class="btn btn-success rounded-pill px-4">
                    <span v-if="submit" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span :class="{ 'visually-hidden': submit }">
                        <i class="ti ti-device-floppy me-1 fs-4"></i> Guardar cambios
                    </span>
                </button>
                <button type="button" @click="onClose()"
                    class="btn btn-danger rounded-pill px-4 ms-2 text-white">Cancelar</button>
            </template>
        </app-model>
    </form>
</template>
<script>
export default {
  props: {
    id: {
      type: String | Number,
      default: null
    },
    submit: {
      type: Boolean,
      default: false
    },
    onEvent: {
      type: Function,
      default: () => { console.log('aca') }
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      show: false,
      users: [],
      category_users: []
    }
  },
  created () {
    if (this.id) {
      this.$axios({
        url: '/categories/' + this.data.id + '/users',
        method: 'GET'
      })
        .then((resp) => {
          this.users = resp.data.users
          this.category_users = resp.data.category_users
          this.show = true
        })
        .catch((_err) => {
          this.show = false
          this.$emit('onClose')
        })
    }
  },
  methods: {
    onClose: function () {
      this.show = false
      this.$emit('onClose')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/categories/models/Users.vue